import React from "react";
import { FilaOperador } from "../../../Callback/fila-atendimento/components/fila-operador";


export const ProximoAtendimento = () => {

  return (
    <>
      <div>
        <h2 className="text-lg font-medium text-primary">
          Escolha seu próximo atendimento:{" "}
        </h2>

        <div className="my-4 max-h-[240px] overflow-y-auto overflow-x-hidden pr-1">
          {/* <FilaOperador /> */}
        </div>

        {/* <Button
          name="Ir para próximo atendimento"
          onClick={() => fecharModal()}
        /> */}
      </div>
    </>
  );
};
